// import Cookies from 'js-cookie'

// 导入storage.js
import { setItem, getItem } from '@/utils/storage'
import {
  recursionArray
} from '@/utils/index'
// 设置用户token键
const key = 'zhrd'
const state = {
  // 当前登录用户的token数据（初始化时候，应该从本地读取）
  token: getItem(key),
  showMenu: true, // 是否显示菜单
  userInfo: localStorage.getItem('userInfo') ? JSON.parse(localStorage.getItem('userInfo')) : {},
  name: '',
  rolesList: [],
  authority: {},
  permissions: [],
  menuCode: []
}

const mutations = {
  setUser (state, data) {
    // 将token保存到Vuex
    state.token = data
    // 将token保存到本地
    setItem(key, state.token)
  },
  setShowMenu (state, data) {
    // 将token保存到Vuex
    state.showMenu = data
    setItem('showMenu', state.showMenu)
  },
  SET_User_Info (state, data) {
    state.userInfo = data
    setItem('userInfo', state.userInfo)
  },
  SET_ROLES (state, data) {
    state.rolesList = data
    setItem('rolesList', state.rolesList)
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_PERMISSIONS: (state, permissions) => {
    state.permissions = permissions
  },
  SET_AUTHORITY: (state, authority) => {
    state.authority = authority
  },
  SET_MENUCODE: (state, menuCode) => {
    state.menuCode = menuCode
  }
}

const actions = {
  setUserInfo ({ commit }, payload) {
    commit('SET_User_Info', payload)
  },
  setToken ({ commit }, payload) {
    commit('setUser', payload)
  },
  setShowMenu ({ commit }, payload) {
    commit('setShowMenu', payload)
  },
  setRoles ({ commit }, payload) {
    commit('SET_ROLES', payload)
  },
  setName ({ commit }, payload) {
    commit('SET_NAME', payload)
  },

  // get user info
  getInfo ({ commit, state }) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'))
    const permissions = userInfo ? userInfo.menuAuthority : []
    const menuCode = permissions.map(item => item.code)
    const authority = recursionArray(permissions, [], 'code', 'functionPermissionCode', 'name') || {}
    commit('SET_NAME', '管理员')
    commit('SET_MENUCODE', menuCode)
    commit('SET_PERMISSIONS', permissions)
    commit('SET_AUTHORITY', authority)
    return '管理员'
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
